var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4895 24C14.4733 24 13.6495 23.1762 13.6495 22.16V1.84C13.6495 0.823796 14.4733 0 15.4895 0H19.1595C20.1757 0 20.9995 0.823796 20.9995 1.84V22.16C20.9995 23.1762 20.1757 24 19.1595 24H15.4895ZM1.83951 24C0.823306 24 -0.000488281 23.1762 -0.000488281 22.16V1.84C-0.000488281 0.823796 0.823308 0 1.83951 0H5.50951C6.52572 0 7.34951 0.823796 7.34951 1.84V22.16C7.34951 23.1762 6.52572 24 5.50951 24H1.83951Z",
    fill: "#3A74F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPause);
export default __webpack_public_path__ + "static/media/player-pause.040b2f39fcbb29b6430afab1ed4c838b.svg";
export { ForwardRef as ReactComponent };